// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background-color: #050505;
  color: #f0f0f0;
  font-family: 'Space Grotesk', system-ui, sans-serif;
}

h1, h2, h3 {
  color: #ff4500;
}

a {
  color: #ff8c00;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.btn {
  background: linear-gradient(90deg, #ff4500, #ff8c00);
  color: #fff;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s;
}

.btn:hover {
  transform: scale(1.05);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  background-color: #050505;\n  color: #f0f0f0;\n  font-family: 'Space Grotesk', system-ui, sans-serif;\n}\n\nh1, h2, h3 {\n  color: #ff4500;\n}\n\na {\n  color: #ff8c00;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.btn {\n  background: linear-gradient(90deg, #ff4500, #ff8c00);\n  color: #fff;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.btn:hover {\n  transform: scale(1.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
